import { Router, Route,Switch, Redirect } from 'react-router-dom';
import './App.css';
import PageLayout from './pages/root/layouts';
import history from './history';
import LoginForm from './pages/root/login';
import { connect } from 'react-redux';
import MessageAlert from './component/messageAlert';
import WrongPage from './component/wrongPage';
import GlobalStyles from './globalStyle';

function App(props) {
  return (
    <>
    
    <GlobalStyles />
    {props.authSuccess ? <MessageAlert type="success" value={props.authSuccess} /> : null}
      {props.authError ? <MessageAlert type="error" value={props.authError} /> : null}
      {props.authValidationError ? 
        props.authValidationError.map((item,id )=> (
          <MessageAlert type="error" value={item.message} />
        ))
        :
        null
      }
    <Router history={history}>
      <Switch>
        
        <Route path="/opps" component={WrongPage}/>
        <Route path="/login" component = {LoginForm} />
        <Route path="/" component = {PageLayout} />
        <Redirect to="/opps" />
      </Switch>
    </Router>
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    authSuccess: state.message.authSuccess,
    authError: state.message.authError,
    authValidationError: state.message.authValidationError,
  };
};
export default connect(mapStateToProps)(App);
